/**
 * @desc 指定列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<Array<defs.srm.SupplierInfoSpecifyDto>>;
export function request(
  params: API.srm.supplierInfo.specifyList.Params,
  options?: ObjectMap,
): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierInfo/specifyList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
